export default {
  lang: 'nl-be',
  messages: {
    /* eslint-disable max-len */
    'app.title': 'CAPE',
    'app.copyright': '© {copyrightYear} International Post Corporation',
    'app.example.do-action': 'Doe actie',
    'error.credentials.invalid': 'De combinatie van de gebruikersnaam en het wachtwoord is incorrect. Gelieve opnieuw te proberen met de juiste gegevens.',
    'app.button.cancel': 'annuleer',
    'app.button.next': 'volgende',
    'app.button.save': 'opslaan',
    'app.button.ok': 'OK',
    'app.button.show.details': 'toon details',
    'app.button.hide.details': 'verberg details',
    'app.field.mandatory': '{field} is verplicht',
    'app.field.max.length': '{field} moet {maxLength} of minder tekens lang zijn',
    'app.field.not.blank': '{field} met alleen spaties zijn niet toegestaan',
    'app.field.already.used': '{field} is al in gebruik',
    'app.no.impcs.selected': 'U moest minstens 1 IMPC selecteren',
    'app.no.mailsubclasses.selected': 'U moet minstens 1 mail sub class selecteren',
    'app.wizard.button.generate-report': 'Rapport genereren',
    'app.save.selection.button.label': 'Sla selectie op',
    'app.save.impc.selection.form.title': 'Sla operator lijst op',
    'app.save.product.selection.form.title': 'Sla producten op',
    'app.save.selection.form.name': 'Naam',
    'app.selection.list.title.label': 'Selecteer op {operatorType} lijst',
    'app.selection.list.empty': 'Geen selecties gevonden',
    'app.selection.list.lastSelection': 'Je laatste selectie',
    'app.report.download': 'Download',
    'app.report.generated.on': 'Gegenereerd op {date} om {time} UTC',
    'app.warning.load.from.summary.report': 'Please click on a link in the summary report.',
    'filter-component.action.filter': 'Filter',
    'filter-component.action.apply': 'Toepassen',
    'filter-component.action.clear-filter': 'Wissen',
    'filter-component.action.cancel': 'Annuleren',
    'filter-component.label.equals': 'Gelijk aan',
    'filter-component.label.greater-than': 'Groter dan',
    'filter-component.label.greater-than-equal-to': 'Groter dan of gelijk aan',
    'filter-component.label.smaller-than': 'Kleiner dan',
    'filter-component.label.smaller-than-equal-to': 'Kleiner dan of gelijk aan',
    'filter-component.label.between': 'Tussen',
    'filter-component.label.contains': 'Bevat',
    'filter-component.label.starts-with': 'Begint met',
    'app.report.clipboard': 'Clipboard',
    /* eslint-enable max-len */
  },
};
